import { requestHandler } from "../lib/utils/network-client";

export function getDoctors(params = {}) {
  return requestHandler("/doctors", {
    params
  });
}

export function createDoctor(payload) {
  return requestHandler("/doctors", {
    method: "POST",
    body: payload
  });
}

export function updateDoctor(id, payload) {
  return requestHandler(`/doctors/${id}`, {
    method: "PUT",
    body: payload
  });
}

export function deleteDoctor(id) {
  return requestHandler(`/doctors/${id}`, {
    method: "DELETE"
  });
}
